(function () {
  'use strict';

  var INKYBAY_PROPERTY_PREFIX = '_inkybay_';
  var SOURCE_URL_PROPERTY = '_source_product_url';
  var POLL_INTERVAL = 1500;

  var knownItemKeys = null;

  function isInkybayItem(properties) {
    if (!properties) return false;
    return Object.keys(properties).some(function (key) {
      return key.indexOf(INKYBAY_PROPERTY_PREFIX) === 0;
    });
  }

  function tagNewItems(cart) {
    cart.items.forEach(function (item) {
      if (knownItemKeys.indexOf(item.key) !== -1) return; // already seen
      if (!isInkybayItem(item.properties)) return;
      if (item.properties[SOURCE_URL_PROPERTY]) return; // already tagged

      var mergedProperties = {};
      Object.keys(item.properties).forEach(function (k) { mergedProperties[k] = item.properties[k]; });
      mergedProperties[SOURCE_URL_PROPERTY] = window.location.pathname;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, properties: mergedProperties })
      }).catch(function () {});
    });
  }

  function poll() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (knownItemKeys === null) {
          // Anything already in the cart on page load is "old" - only react
          // to items added while the shopper is on this page.
          knownItemKeys = cart.items.map(function (item) { return item.key; });
          return;
        }
        tagNewItems(cart);
        knownItemKeys = cart.items.map(function (item) { return item.key; });
      })
      .catch(function () {});
  }

  setInterval(poll, POLL_INTERVAL);
  poll();
})();
